<template>
    <page>
        <div class="shadow-25 col-4">
            <v-header :title="'4003 - ' + $T('no user in app')" icon="error"/>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <div class="q-pa-xl text-center">
                    {{ $T('the user does not exists in the app.') }}
                </div>
            </card>
        </div>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NoLendingPoint'
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/4003.vue